import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Input } from 'antd';
import { VALIDATION_MESSAGES } from '../../constants/categories';

const AddCategoryModal = ({
  visible,
  onCancel,
  onOk,
  nameStatus,
  nameHelp,
  slugStatus,
  slugHelp,
  categoryName,
  categorySlug,
  categoryDescription,
  onNameChange,
  onSlugChange,
  onDescriptionChange,
  descriptionStatus,
  descriptionHelp,
}) => {
  return (
    <Modal
      title="Add Category"
      open={visible}
      onCancel={onCancel}
      onOk={onOk}
      destroyOnClose
    >
      <Form layout="vertical">
        <Form.Item
          label="Category Name"
          required
          validateStatus={nameStatus}
          help={nameHelp}
          tooltip="Enter a descriptive name for your category (minimum 3 characters)"
        >
          <Input
            placeholder="Enter category name"
            value={categoryName}
            onChange={onNameChange}
          />
        </Form.Item>

        <Form.Item
          label="URL-Friendly"
          required
          validateStatus={slugStatus}
          help={slugHelp}
          tooltip="This will be used in the URL. Auto-generated from category name, contains only lowercase letters, numbers, and hyphens"
        >
          <Input
            placeholder="url-friendly-name"
            value={categorySlug}
            onChange={onSlugChange}
          />
        </Form.Item>

        <Form.Item
          label="Description"
          validateStatus={descriptionStatus}
          help={descriptionHelp}
          tooltip="Provide a clear description of what this category represents"
        >
          <Input.TextArea
            placeholder="Enter category description"
            value={categoryDescription}
            onChange={onDescriptionChange}
            rows={4}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddCategoryModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired,
  nameStatus: PropTypes.string,
  nameHelp: PropTypes.string,
  slugStatus: PropTypes.string,
  slugHelp: PropTypes.string,
  categoryName: PropTypes.string,
  categorySlug: PropTypes.string,
  categoryDescription: PropTypes.string,
  onNameChange: PropTypes.func.isRequired,
  onSlugChange: PropTypes.func.isRequired,
  onDescriptionChange: PropTypes.func.isRequired,
  descriptionStatus: PropTypes.string,
  descriptionHelp: PropTypes.string,
};

export default AddCategoryModal; 